const ITEMS = ["CHRISTIAN MUSIC", "BRINGING THE CONCERT TO YOU", "INTIMATE LIVE MUSIC"];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {Array.from({ length: 6 }).map((_, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="px-8 font-serif text-2xl sm:text-3xl font-light italic text-sand/70">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
          </span>
        ))}
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/[0.06] bg-charcoal-900/60 py-5">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </div>
);
